<div class="wrapper" style="background-color: #eaebec;">
    <div class="container-fluid">
        <div class="row mt-3">
            <div class="col">
                <div class="card">
                    <div class="card-header">Upload Price List</div>
                    <div class="card-body">
                        <div class="card-text">
                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label class="control-label">Price List Name</label>
                                        <input type="text" placeholder="Price List Name"
                                            [(ngModel)]="uploadNewPriceListName" class="form-control form-control-sm" />
                                    </div>
                                </div>
                                <div class="col">
                                    <app-client-select-modal [clientObject]="choosenClientObject" (clientSelected)="onClientSelectedEvent($event)">
                                    </app-client-select-modal>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="form-group" style="margin: 0;">
                                        <div class="custom-file">
                                            <input type="file" #priceListInput class="custom-file-input" id="customFile"
                                                (change)="handlePriceListFileInput($event)"
                                                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
                                            <label class="custom-file-label {{'shared.langCode' | translate}}" for="customFile">
                                              {{uploadNewPriceListLabel}}</label>
                                        </div>
                                        <small class="form-text text-muted">
                                          {{'price-list.dashboard.uploadPriceList' | translate}}
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col text-right">
                                    <button type="button" class="btn btn-primary btn-sm"
                                        (click)="uploadNewPriceListClickEvent()">Upload</button>
                                </div>
                            </div>
                            <div class="row" *ngIf="priceListUploadError" style="padding:30px 0px;">
                              <div class="col">
                                <div class="alert alert-warning" role="alert" [innerHTML]="priceListUploadError"></div>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--
            <div class="col">
                <div class="card">
                    <div class="card-header">Create Price List</div>
                    <div class="card-body">
                        <div class="card-text">
                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label class="control-label">Price List Name</label>
                                        <input type="text" placeholder="Price List Name" [(ngModel)]="newPriceListName"
                                            class="form-control form-control-sm" />
                                    </div>
                                </div>
                                <div class="col">
                                    <app-client-select-modal (clientSelected)="onClientSelectedEvent($event)">
                                    </app-client-select-modal>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col text-right">
                                    <button type="button" class="btn btn-primary btn-sm"
                                        (click)="createNewPriceListClickEvent()">Create</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          -->
        </div>
        <div class="row mt-3">
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <app-data-table pageSize="45" [columns]="columns" [loadPage]="loadPage" [(filters)]="filters"
                            [filtersComponent]="dataFilters" [tBodyTrAdditionalClass]="tBodyTrAdditionalClass">
                            <app-data-filters #dataFilters>
                                <app-data-filter-group>
                                    <app-data-filter-input label="Price List Name Filter" [(model)]="filters.name"
                                        placeholder="Price List Name Filter">
                                    </app-data-filter-input>
                                    <app-data-filter-datepicker label="Creation Date Filter"
                                        [(model)]="filters.creationDate">
                                    </app-data-filter-datepicker>
                                </app-data-filter-group>
                            </app-data-filters>
                        </app-data-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #selectColumn let-id="id">
    <input type="checkbox" [value]="id" />
</ng-template>

<ng-template #nameColumn let-name="name">
    {{name}}
</ng-template>

<ng-template #createAtColumn let-createdAt="createdAt">
    {{createdAt | date: 'dd-MM-yyyy'}}
</ng-template>

<ng-template #statusColumn let-status="status" let-id="id">
    <ng-container *ngIf="status == 1; else disabledTemplate">
        <i style="color: green; cursor: pointer;" class="fas fa-check" (click)="changePriceListStatus(id, 0)"></i>
    </ng-container>
    <ng-template #disabledTemplate>
        <i style="color: red; cursor: pointer;" class="fas fa-times" (click)="changePriceListStatus(id, 1)"></i>
    </ng-template>
</ng-template>

<ng-template #associatedEventColumn let-event="event">
    {{(event ? event.eventName: '')}}
</ng-template>

<ng-template #associatedCompanyColumn let-company="company">
    {{(company ? company.name : '')}}
</ng-template>


<ng-template #viewColumn let-id="id">
    <div class="btn-group btn-group-sm" role="group" aria-label="Basic example">
        <a href="price-lists/papers/summery/{{id}}" target="_blank" class="btn btn-secondary"><i class="fa fa-eye"></i>
            View</a>
    </div>
</ng-template>

<ng-template #actionsColumn let-id="id" let-company="company" let-name="name">
    <div class="btn-group btn-group-sm" role="group" aria-label="Basic example">
        <button type="button" class="btn btn-secondary" placement="top" ngbTooltip="Export"
            (click)="exportPriceList(id, name)"><i class="fa fa-file-download"></i></button>
        <a href="price-lists/edit/{{id}}" class="btn btn-secondary" placement="top" ngbTooltip="Edit"><i
                class="fa fa-edit"></i></a>
        <button type="button" class="btn btn-secondary" placement="top" ngbTooltip="Delete"
            (click)="onDeletePriceListClickEvent(id)"><i class="fa fa-trash"></i></button>
        <button type="button" class="btn btn-secondary" placement="top" ngbTooltip="Duplicate"
            (click)="duplicatePriceListButtonClickEvent(id, company.id)"><i class="fa fa-copy"></i></button>
    </div>
</ng-template>

<app-confirm-dialog-model #confirmDeletePriceListDialog (getResult)="getDeletePriceListDecision($event)"
    [modalTitle]="'price-list.deleteProductPriceListTitle' | translate"
    [modalContent]="'price-list.deleteProductPriceListMsg' | translate" [denyText]="'price-list.no' | translate"
    [acceptText]="'price-list.yes' | translate">
</app-confirm-dialog-model>

<ng-template #duplicatePriceListModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" style="margin-top: 0px;">Duplicate Price List</h4>
    </div>
    <div class="modal-body">
        <div class="d-flex justify-content-center" *ngIf="showModalLoading">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div class="" *ngIf="!showModalLoading">
            <div class="form-check">
                <input class="form-check-input" type="radio" name="duplicationMethod" id="duplicationMethodKeep"
                    [(ngModel)]="duplicationMethod" value="1" (change)="onDuplicateMethodChange()">
                <label class="form-check-label" for="duplicationMethodKeep">
                    Keep existing Company
                </label>
            </div>
            <div class="form-check">
                <input class="form-check-input" type="radio" name="duplicationMethod" id="duplicationMethodNew"
                    [(ngModel)]="duplicationMethod" value="2" (change)="onDuplicateMethodChange()">
                <label class="form-check-label" for="duplicationMethodNew">
                    Move to new Company
                </label>
            </div>
            <div [hidden]="hideCompanySearch">
                <app-select-search [options]="companySelectSearchOptions" [disabled]="true"
                    [(model)]="selectedModalCompany">
                </app-select-search>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger btn-sm mr-3" [disabled]="disableModalButtons"
            (click)="modal.dismiss('close')">Close</button>
        <button type="button" class="btn btn-primary btn-sm" [disabled]="disableModalButtons"
            (click)="modal.close('save')">Duplicate</button>
    </div>
</ng-template>
